// Analytics endpoint (uses same base URL as v1 API)
export const ANALYTICS_ENDPOINT = '/v1/stream/ingest';

// PostHog-only events - stay in PostHog, NOT sent to backend
export const POSTHOG_ONLY_EVENTS = [
  '$pageview',
  '$pageleave',
  '$rageclick',
  '$dead_click',
  '$exception',
  '$web_vitals',
  '$set',
  '$identify',
  '$feature_flag_called',
  '$groupidentify',
  '$create_alias',
  '$opt_in',
  '$session_start',
  '$autocapture',
  '$snapshot',
  '$$heatmap',
];

// Events that go to BOTH backend AND PostHog
export const DUAL_SEND_EVENTS = [];

// Sensitive fields to redact from event properties before sending
export const SENSITIVE_PROPERTY_FIELDS = [
  'password', 'newPassword', 'oldPassword',
  'accessToken', 'refreshToken', 'idToken', 'authToken',
  'phoneNumber', 'phone',
  'pin', 'code', 'giftCardCode', 'redemptionCode', 'claimCode',
];

// PII fields to redact from network request/response bodies (recursive)
// Superset of SENSITIVE_PROPERTY_FIELDS + user profile PII
export const PII_NETWORK_FIELDS = new Set([
  ...SENSITIVE_PROPERTY_FIELDS,
  'email', 'firstName', 'lastName',
  'stripeCustomerId', 'affiliate_cid',
  'balance', 'currentBalance', 'pendingBalance', 'paidBalance', 'currentMonthPaidBalance',
  'cashbackMultiplierValue',
  'stores', 'segments',
]);

export const MAX_RETRIES = 3;
export const RETRY_DELAY_MS = 1000;
export const QUEUE_KEY = 'analytics_retry_queue';
export const MAX_QUEUE_SIZE = 100;
